import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";
import EmbedExploreData from "../Publish/EmbedExploreData"

export const productJson = [
    { 
        productName : 'Digital Display',
        icon: <FontAwesomeIcon type={'light'} icon={'display'} iconClass={'fs-4 text-dark-500'} />,
        value: 'display'
    },
    { 
        productName : 'Website',
        icon: <FontAwesomeIcon type={'light'} icon={'browser'} iconClass={'fs-4 text-dark-500'} />,
        value: 'widget'
    }
]

export const displayUseCase = [
    { 
        productName : 'Projector/TV',
        icon: <FontAwesomeIcon type={'light'} icon={'projector'} iconClass={'fs-4 text-dark-500'} />,
        value: 'projector'
    },
    { 
        productName : 'Digital Signage',
        icon: <FontAwesomeIcon type={'light'} icon={'presentation-screen'} iconClass={'fs-4 text-dark-500'} />,
        value: 'signage'
    },
    { 
        productName : 'Virtual Events',
        icon: <FontAwesomeIcon type={'light'} icon={'screen-users'} iconClass={'fs-4 text-dark-500'} />,
        value: 'events'
    }
]

const embedOption = EmbedExploreData[2];
export const widgetEmbed = embedOption.map(item => ({...item, classActive: ""}));